import React from 'react';
import { Circle, Polygon, Popup } from 'react-leaflet';
import { useMapStore } from '../../store/useMapStore';

export const GeofenceLayer: React.FC = () => {
  const { geofences } = useMapStore();

  return (
    <>
      {geofences.map((geofence) => {
        const popupContent = (
          <div className="p-2">
            <h4 className="font-semibold text-gray-900 mb-2">{geofence.name}</h4>
            <div className="space-y-1 text-sm text-gray-600">
              <div>Type: {geofence.type}</div>
              <div>Bikes Inside: {geofence.bikes_inside}</div>
              <div>Bikes Outside: {geofence.bikes_outside}</div>
              {geofence.radius && (
                <div>Radius: {geofence.radius}km</div>
              )}
            </div>
          </div>
        );

        if (geofence.type === 'circle' && geofence.radius && geofence.coordinates[0]) {
          const center = geofence.coordinates[0];
          return (
            <Circle
              key={geofence.id}
              center={[center.latitude, center.longitude]}
              radius={geofence.radius * 1000} // Convert km to meters
              pathOptions={{
                color: '#f59e0b',
                fillColor: '#f59e0b',
                fillOpacity: 0.1,
                weight: 2,
              }}
            >
              <Popup>{popupContent}</Popup>
            </Circle>
          );
        }

        if (geofence.type === 'polygon') {
          const positions = geofence.coordinates.map(coord => 
            [coord.latitude, coord.longitude] as [number, number]
          );

          return (
            <Polygon
              key={geofence.id}
              positions={positions}
              pathOptions={{
                color: '#8b5cf6',
                fillColor: '#8b5cf6',
                fillOpacity: 0.1,
                weight: 2,
              }}
            >
              <Popup>{popupContent}</Popup>
            </Polygon>
          );
        }

        return null;
      })}
    </>
  );
};